module.exports = __webpack_public_path__ + "static/success.e8b2c6e5.png";